

export default function GenerateSlug(id, name) {
    if (name)
      return id + '-' + name.toLowerCase().replace(/[^\w ]+/g,'').replace(/ +/g,'-');
    else
      return id;
  }